(function () {
    const originalFetch = window.fetch;

    // Make handleCartUpdate globally accessible
    async function handleCartUpdate() {
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            AddAutomaticGiftCard(cart);
        } catch (e) {
            console.error('Error getting the cart', e);
        }
    }
    window.handleCartUpdate = handleCartUpdate;

    document.addEventListener('DOMContentLoaded', handleCartUpdate);

    document.addEventListener('click', function (e) {
        const target = e.target.closest('button[name="add"]');
        if (target) {
            waitForCartChange().then(() => {
                handleCartUpdate();
            });
        }
    });

    // Promise that resolves when the cart item count increases
    function waitForCartChange(timeout = 3000, interval = 100) {
        return new Promise((resolve, reject) => {
            let start = Date.now();
            let initialCount = 0;

            // Get the initial cart count
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    initialCount = cart.item_count;
                    poll();
                })
                .catch(reject);

            function poll() {
                fetch('/cart.js')
                    .then(res => res.json())
                    .then(cart => {
                        if (cart.item_count > initialCount) {
                            resolve();
                        } else if (Date.now() - start > timeout) {
                            resolve(); // Resolve anyway after timeout
                        } else {
                            setTimeout(poll, interval);
                        }
                    })
                    .catch(reject);
            }
        });
    }

    window.fetch = async function (...args) {
        const url = args[0];
        const response = await originalFetch.apply(this, args);
        // Detect any cart CRUD operation
        if (
            url.includes('/cart/add.js') ||
            url.includes('/cart/change.js') ||
            url.includes('/cart/update.js')
        ) {
            // Add a small delay to ensure the cart is updated before handling
            setTimeout(() => { handleCartUpdate(); }, 150); 
        }
        return response;
    };
})();